// extracted by mini-css-extract-plugin
export var actions = "_ts-4";
export var item = "_ts-1";
export var price = "_ts-3";
export var quantity = "_ts-2";
export var table = "_ts-0";